import { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "..";
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [user, setUser] = useState(localStorage.getItem("user"));

  // useEffect(() => {
  //   // if (token) navigate("/");
  //   // alert("in login auth ");
  //   // console.log("thusn is authcontext ", AuthContext, token);
  //   // const savedToken = localStorage.getItem("token");
  //   // const savedUser = localStorage.getItem("user");
  //   // if (savedToken) {
  //   //   setToken(savedToken);
  //   //   alert(savedToken);
  //   // }
  //   // if (savedUser) {
  //   //   setUser(JSON.parse(savedUser));
  //   // }
  // }, []);

  const login = async ({ password, email }) => {
    try {
      // alert("trying login");
      const response = await fetch(`${api}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password, email }),
      });
      const data = await response.json();
      console.log("LOGIN DATA >>", data, data.data.token);

      // Save token and user details to localStorage
      localStorage.setItem("token", data.data.token);
      localStorage.setItem("user", JSON.stringify(data.data.user_details));

      setToken(data.data.token);
      setUser(data.data.user_details);
      // navigate("/");
    } catch (error) {
      console.error(error);
    }
  };
  const logout = async () => {
    try {
      // await fetch("/logout", { method: "POST" });
      console.log(AuthContext);
      alert("logout ");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      setToken(null);
      setUser(null);
      navigate("/");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
